import { BreakpointsMinQuery } from '@ab-core/breakpoints';
import styled from 'styled-components';

export const FallbackWrapper = styled.div`
    @media ${BreakpointsMinQuery.sm} {
        height: 26px;
    }
`;
